import { render, staticRenderFns } from "./infos-etat-de-perte.vue?vue&type=template&id=0ccca63e&scoped=true"
import script from "./infos-etat-de-perte.vue?vue&type=script&lang=ts"
export * from "./infos-etat-de-perte.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccca63e",
  null
  
)

export default component.exports